var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1689_29201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66683 10.6668C8.66683 11.035 8.36835 11.3335 8.00016 11.3335C7.63197 11.3335 7.3335 11.035 7.3335 10.6668C7.3335 10.2986 7.63197 10.0002 8.00016 10.0002C8.36835 10.0002 8.66683 10.2986 8.66683 10.6668Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50016 4.66683C8.50016 4.39069 8.27631 4.16683 8.00016 4.16683C7.72402 4.16683 7.50016 4.39069 7.50016 4.66683V8.66683C7.50016 8.94297 7.72402 9.16683 8.00016 9.16683C8.27631 9.16683 8.50016 8.94297 8.50016 8.66683V4.66683Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833496C4.04212 0.833496 0.833496 4.04212 0.833496 8.00016C0.833496 11.9582 4.04212 15.1668 8.00016 15.1668C11.9582 15.1668 15.1668 11.9582 15.1668 8.00016C15.1668 4.04212 11.9582 0.833496 8.00016 0.833496ZM1.8335 8.00016C1.8335 4.59441 4.59441 1.8335 8.00016 1.8335C11.4059 1.8335 14.1668 4.59441 14.1668 8.00016C14.1668 11.4059 11.4059 14.1668 8.00016 14.1668C4.59441 14.1668 1.8335 11.4059 1.8335 8.00016Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1689_29201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerCircle);
export default __webpack_public_path__ + "static/media/DangerCircle.dc8f3d0fcc6ca3b2b30a9acf92061f50.svg";
export { ForwardRef as ReactComponent };